<div class="mx-auto w-full h-full justify-center space-y-6 sm:w-96">
  <div class="space-y-2 text-center">
    <h1 class="text-2xl font-semibold tracking-tight">Inizia la tua prova gratuita</h1>
    <p class="text-muted-foreground text-sm">
      14 giorni di accesso completo, nessuna carta richiesta
    </p>
  </div>
  <div class="grid gap-6">
    <form
      [formGroup]="form"
      (ngSubmit)="signUp()"
      class="flex flex-col gap-y-2.5"
    >
      @if (signUpState() === signUpEnum.FAIL) {
        <p class="text-destructive text-sm text-center">
          Errore durante la registrazione
        </p>
      }
      @if (errorMessage()) {
        <p class="text-destructive text-sm text-center">
          {{ errorMessage() }}
        </p>
      }

      <div class="space-y-2">
        <label hlmLabel> Email </label>
        <input
          hlmInput
          class="w-full"
          type="email"
          id="email"
          formControlName="email"
          placeholder="email@azienda.com"
          autocomplete="off"
        />
      </div>

      <div class="space-y-2">
        <label hlmLabel> Password </label>
        <o2-password-input
          class="w-full"
          formControlName="password"
          placeholder="Crea una password sicura"
        />
      </div>

      <div class="space-y-2">
        <label hlmLabel> Conferma password </label>
        <o2-password-input
          class="w-full"
          formControlName="confirmPassword"
          placeholder="Conferma la password"
        />
      </div>

      <!-- Password requirements checklist -->
      <div class="text-sm space-y-1">
        <p class="text-muted-foreground font-medium mb-2">
          La password deve contenere:
        </p>
        <div
          class="flex items-center gap-2"
          [class.text-green-600]="passwordValidation.minLength"
          [class.text-muted-foreground]="!passwordValidation.minLength"
        >
          <ng-icon
            hlm
            [name]="passwordValidation.minLength ? 'lucideCheck' : 'lucideX'"
            size="sm"
          />
          <span>Almeno 8 caratteri</span>
        </div>
        <div
          class="flex items-center gap-2"
          [class.text-green-600]="passwordValidation.uppercase"
          [class.text-muted-foreground]="!passwordValidation.uppercase"
        >
          <ng-icon
            hlm
            [name]="passwordValidation.uppercase ? 'lucideCheck' : 'lucideX'"
            size="sm"
          />
          <span>Una lettera maiuscola</span>
        </div>
        <div
          class="flex items-center gap-2"
          [class.text-green-600]="passwordValidation.lowercase"
          [class.text-muted-foreground]="!passwordValidation.lowercase"
        >
          <ng-icon
            hlm
            [name]="passwordValidation.lowercase ? 'lucideCheck' : 'lucideX'"
            size="sm"
          />
          <span>Una lettera minuscola</span>
        </div>
        <div
          class="flex items-center gap-2"
          [class.text-green-600]="passwordValidation.number"
          [class.text-muted-foreground]="!passwordValidation.number"
        >
          <ng-icon
            hlm
            [name]="passwordValidation.number ? 'lucideCheck' : 'lucideX'"
            size="sm"
          />
          <span>Un numero</span>
        </div>
        <div
          class="flex items-center gap-2"
          [class.text-green-600]="passwordValidation.specialChar"
          [class.text-muted-foreground]="!passwordValidation.specialChar"
        >
          <ng-icon
            hlm
            [name]="passwordValidation.specialChar ? 'lucideCheck' : 'lucideX'"
            size="sm"
          />
          <span>Un carattere speciale (!&#64;#$%...)</span>
        </div>
        @if (form.get("confirmPassword")?.value) {
          <div
            class="flex items-center gap-2 mt-2"
            [class.text-green-600]="passwordsMatch"
            [class.text-destructive]="!passwordsMatch"
          >
            <ng-icon
              hlm
              [name]="passwordsMatch ? 'lucideCheck' : 'lucideX'"
              size="sm"
            />
            <span>Le password coincidono</span>
          </div>
        }
      </div>

      <button hlmBtn [disabled]="isLoading()" class="mt-4 w-full">
        @if (isLoading()) {
          <hlm-spinner class="mr-2" />
        }
        Avvia prova gratuita
      </button>

      <button
        hlmBtn
        variant="link"
        [disabled]="isLoading()"
        class="mt-4 w-full"
        (click)="onSignInClick()"
        type="button"
      >
        Hai già un account? Accedi
      </button>
    </form>
  </div>
</div>
